import Api, { FetchMethodType } from 'api/Api';
import { ValidateEmployerProvidedIncomeData } from 'thunks/createValidateEmployerProvidedIncomeThunk';
import { GetApplicationDataResponse } from 'handlers/applicationData';

export enum PayrollProviderName {
  Manual = 'Manual',
  ManuallySendToHR = 'ManuallySendToHR',
}

export interface EmployerData {
  id: string;
  name: string;
  logo_url: string;
}

export interface ValidateEmployerProvidedIncomeResponse {
  incomeRequired: boolean;
}

export default class EmployersApi extends Api {
  public async getEmployerData(payrollProvider: string, employerId: string): Promise<EmployerData> {
    const result = await this.fetch(`/employers/${payrollProvider}/linkItem/${employerId}`);
    return result as EmployerData;
  }

  public async validateEmployerProvidedIncome(
    data: ValidateEmployerProvidedIncomeData,
  ): Promise<ValidateEmployerProvidedIncomeResponse> {
    const result = await this.fetch('/employers/validateEmployerProvidedIncome', {
      method: FetchMethodType.POST,
      body: data,
    });
    return result as ValidateEmployerProvidedIncomeResponse;
  }

  public async updatePayrollProviderToManual(applicationId: string): Promise<GetApplicationDataResponse> {
    const result = await this.fetch<GetApplicationDataResponse>(`/employers/${applicationId}/payrollProvider`, {
      method: FetchMethodType.PUT,
    });

    return result;
  }
}
